import { render, staticRenderFns } from "./SlideshowNavButton.vue?vue&type=template&id=661196c8&scoped=true&"
import script from "./SlideshowNavButton.vue?vue&type=script&lang=js&"
export * from "./SlideshowNavButton.vue?vue&type=script&lang=js&"
import style0 from "./SlideshowNavButton.vue?vue&type=style&index=0&id=661196c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661196c8",
  null
  
)

export default component.exports